import { render } from "./SurveyMultipleChoice.vue?vue&type=template&id=3ef34d64&scoped=true"
import script from "./SurveyMultipleChoice.vue?vue&type=script&lang=js"
export * from "./SurveyMultipleChoice.vue?vue&type=script&lang=js"

import "./SurveyMultipleChoice.vue?vue&type=style&index=0&id=3ef34d64&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef34d64"]])

export default __exports__